import { GET_EXISTING_MOBILE_FAILURE, GET_EXISTING_MOBILE_SUCCESS, GET_EXISTING_MOBILE_REQUEST, GET_CHANGE_MOBILE_CARD_PROFILE_FAILURE, GET_CHANGE_MOBILE_CARD_PROFILE_REQUEST, GET_CHANGE_MOBILE_CARD_PROFILE_SUCCESS } from "@/actions/changemobileno/actionTypes";

export const initialState = {
  isExistingServiceNoLoading: false,
  existingServiceNoList: [],
  paginationRecord: 0,
  isLoadingSimType: false,
  simTypeError: ''
};

const changeMobileReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_EXISTING_MOBILE_REQUEST:
      return {
        ...state,
        isExistingServiceNoLoading: true
      };
    case GET_EXISTING_MOBILE_SUCCESS:
      return {
        ...state,
        existingServiceNoList: action.data.data,
        paginationRecord: action.data.totalRecords,
        isExistingServiceNoLoading: false
      };
    case GET_EXISTING_MOBILE_FAILURE:
      return {
        ...state,
        isExistingServiceNoLoading: false,
        existingServiceNoList: [],
        paginationRecord: 0
      };

    case GET_CHANGE_MOBILE_CARD_PROFILE_REQUEST:
      return {
        ...state,
        isLoadingSimType: true,
        simTypeError: ''
      };
    case GET_CHANGE_MOBILE_CARD_PROFILE_SUCCESS:
      return {
        ...state,
        isLoadingSimType: false
      };
    case GET_CHANGE_MOBILE_CARD_PROFILE_FAILURE:
      return {
        ...state,
        isLoadingSimType: false,
        simTypeError: action.error.response?.data?.message
      };

    default:
      return state;
  }
};

export default changeMobileReducers;
